import React, { useEffect, useRef } from "react";
import dots from "../../../assets/images/dots.png";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { AgastyaLogo } from "../../../assets/styles/AgastyaLogo.tsx";

export default function SalesSection() {
  const titleRef = useRef(null);
  const descriptionRef = useRef(null);

  const sectionRef = useRef(null);

  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);

    const ctx = gsap.context(() => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: titleRef.current,
          start: "top 85%",
          toggleActions: "play none none reverse",
        },
      });

      tl.fromTo(
        titleRef.current,
        { y: 30, opacity: 0 },
        { y: 0, opacity: 1, duration: 0.6, ease: "power3.out" }
      ).fromTo(
        descriptionRef.current,
        { y: 20, opacity: 0 },
        { y: 0, opacity: 1, duration: 0.5 },
        "-=0.3"
      );
    }, sectionRef);

    return () => ctx.revert();
  }, []);

  return (
    <section ref={sectionRef} className="relative overflow-hidden">
      
      <div
        className="absolute inset-0 z-0 bg-center bg-cover"
        style={{ backgroundImage: `url(${dots})` }}
      />

      {/* Main Content */}
      <div className="relative z-10 flex flex-col justify-center items-center md:items-start px-5 sm:px-6 md:px-8 lg:px-8  pt-[88px] pb-[120px] md:pt-[96px] md:pb-[140px]  max-w-[1200px] mx-auto">

         {/* Logo */}
         {/* <div className="mb-[56px] md:mb-[72px]">
           <AgastyaLogo className="w-40 md:w-48 h-auto opacity-60"/>
         </div> */}

        {/* Icon */}
        <div className="mb-6">
          <svg width="25" height="73" viewBox="0 0 25 73" fill="none">
            <line x1="12.4" y1="24" x2="12.4" y2="72" stroke="white" strokeWidth="1.4"/>
            <rect x="0.5" y="0.5" width="23" height="15" rx="5" stroke="white" strokeWidth="1"/>
            <circle cx="12.4" cy="8.1" r="3.6" fill="white"/>
          </svg>
        </div>

        {/* Headline */}
        <div className="mb-6 md:mb-10 text-center md:text-left">
          <h1
            ref={titleRef}
            className="text-[26px] sm:text-[30px] md:text-[44px] lg:text-[56px] font-bold text-[#F7F7F7] leading-tight opacity-0 flex flex-col md:block items-center"
          >
            <span className="block md:inline font-[LTWave]">Driving In</span>{" "}
            <span className="inline-flex justify-center items-center mt-3 md:mt-0  bg-gradient-to-r from-[#2a2a2a] to-[#1a1a1a] px-4 md:px-5 py-2 rounded-lg">
              <span className="sales-section__gradient-mobile md:sales-section__gradient bg-clip-text text-transparent font-[LTWave] font-black">
                $42 million USD
              </span>
            </span>
          </h1>

          <h2 className="text-[26px] sm:text-[30px] md:text-[44px] lg:text-[56px] font-[LTWave] font-bold text-[#F7F7F7] px-8 md:px-0 leading-tight mt-2 text-center md:text-left">
            Agri-Sales Across The Nation.
          </h2>
        </div>

        {/* Description */}
        <p
          ref={descriptionRef}
          className="text-[14px] sm:text-[15px] md:text-base text-[#858585] max-w-md font-inter leading-relaxed opacity-0 text-center md:text-left mt-4">
          Agastya Agro Tech has contributed to over $42 million in sales, reflecting our strong impact and trust in the agriculture sector, driving innovation, sustainability, growth, excellence, and long-term value globally.
        </p>
      </div>

      {/* Bottom Gradient Bar */}
      <div className="absolute bottom-0 left-0 w-full h-[44px] z-20">
        <div className="h-full bg-gradient-to-l from-[#6B2E2F] via-[#C94B1A] to-[#FFA500] flex items-center justify-center">
          <AgastyaLogo className="w-24 md:w-32 h-auto fill-white" />
        </div>
      </div>

      {/* Gradient Animation Styles */}
      <style>{`
                .sales-section__gradient-mobile {
                    background: linear-gradient(
                        -50deg,
                        #FFA500,
                        #FF4500,
                        #8B0000,
                        #FFA500
                    );
                    background-size: 200% 200%;
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                    background-clip: text;
                    animation: salesGradientShiftMobile 8s ease infinite;
                }

                .sales-section__gradient {
                    background: linear-gradient(
                        -50deg,
                        #FFA500,
                        #FF4500,
                        #8B0000,
                        #FFA500
                    );
                    background-size: 400% 400%;
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                    background-clip: text;
                    animation: salesGradientShift 6s ease infinite;
                }

                @keyframes salesGradientShiftMobile {
                    0% { background-position: 0% 50%; }
                    50% { background-position: 100% 50%; }
                    100% { background-position: 0% 50%; }
                }

                @keyframes salesGradientShift {
                    0% { background-position: 0% 50%; }
                    50% { background-position: 100% 50%; }
                    100% { background-position: 0% 50%; }
                }
            `}</style>
    </section>
  );
}
